import React from 'react';
import { StyleProp, ViewStyle } from 'react-native';
import { MBLinkPreview } from '@shared/scenes/chat/linkPreview/containers';
import { API } from '@shared/types/api';

interface MBLinkPreviewFromTokensProps {
  message: API.ChatMessageFragment;
  style?: StyleProp<ViewStyle>;
  onLongPress?: (url: string, node: React.Component) => void;
}

/*
    Render link preview based on a message's tokens. It shows the first link, if any.
*/
export function MBLinkPreviewFromTokens({
  message,
  style,
  onLongPress,
}: MBLinkPreviewFromTokensProps) {
  const urlToken = message.meta.tokens.find(token => token?.type === 'url');
  if (!urlToken) {
    return null;
  }

  return <MBLinkPreview url={urlToken.value} style={style} onLongPress={onLongPress} />;
}
